import React, { useState } from 'react';
import * as Icons from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { Box } from '@mui/material';
import { ButtonUI } from '../Interface';

const IconPalette = ({ handlePopoverClose }) => {
  const { setFieldValue } = useFormikContext();
  const iconEntries = Object.entries(Icons);
  const [category, setCategory] = useState('Outlined');
  const [page, setPage] = useState(0);
  const iconsPerPage = 50;

  const filteredIcons = iconEntries.filter(([name]) => name.endsWith(category));
  const paginatedIcons = filteredIcons.slice(page * iconsPerPage, (page + 1) * iconsPerPage);

  const handleClick = (iconName) => {
    setFieldValue('icon', iconName);
    handlePopoverClose();
  };

  const handleCategoryChange = (newCategory) => {
    setCategory(newCategory);
    setPage(0);
  };

  return (
    <Box maxHeight="550px" width="600px" px="0.5rem">
      <Box display="flex" gap="0.5rem" mb="2rem">
        <ButtonUI
          text="Körvonalas"
          size="sm"
          onClick={() => handleCategoryChange('Outlined')}
          className="px-2 mt-5 bg-warning"
        />
        <ButtonUI
          text="Kerekített"
          size="sm"
          onClick={() => handleCategoryChange('Rounded')}
          className="px-2 mt-5 bg-warning"
        />
        <ButtonUI
          text="Kéttónusú"
          size="sm"
          onClick={() => handleCategoryChange('TwoTone')}
          className="px-2 mt-5 bg-warning"
        />
        <ButtonUI
          text="Éles"
          size="sm"
          onClick={() => handleCategoryChange('Sharp')}
          className="px-2 mt-5 bg-warning"
        />
      </Box>

      <Box display="flex" flexWrap="wrap" gap="0.5rem">
        {paginatedIcons.map(([name, IconComponent]) => (
          <Box key={name} onClick={() => handleClick(name)}>
            <IconComponent sx={{ fontSize: 32, cursor: 'pointer' }} />
          </Box>
        ))}
      </Box>

      <Box display="flex" justifyContent="center" gap="1rem" my="1rem">
        <ButtonUI
          text="Előző"
          size="sm"
          onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
          disabled={page === 0}
          variant="outlined"
        />
        <ButtonUI
          text="Következő"
          size="sm"
          onClick={() =>
            setPage((prev) => (prev + 1 < Math.ceil(filteredIcons.length / iconsPerPage) ? prev + 1 : prev))
          }
          disabled={(page + 1) * iconsPerPage >= filteredIcons.length}
          variant="outlined"
        />
      </Box>
    </Box>
  );
};

export default IconPalette;
